import { render, staticRenderFns } from "./OriginCreateUpdate.vue?vue&type=template&id=20919c41&scoped=true&"
import script from "./OriginCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./OriginCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./OriginCreateUpdate.vue?vue&type=style&index=0&id=20919c41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20919c41",
  null
  
)

export default component.exports